import type { SvgProps } from "../types";

export const CocktelSvg = ({
  width = "100px",
  height = width,
  color = "#000000",
}: SvgProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 400 400"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Cocktel</title>
      <path
        d="M118.915 90.1241C168.812 87.5949 218.509 90.1241 268.388 90.1241C279.349 90.1241 290.163 90.8359 301.128 90.8359C303.74 90.8359 308.96 88.2234 308.96 90.8359C308.96 93.3463 290.817 110.718 288.25 113.652C274.783 129.074 210.273 207.394 191.518 212.759C185.803 214.395 99.7788 111.099 92 104.42"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        opacity="0.503384"
        d="M136.57 126.962C147.919 125.111 253.329 119.225 253.329 130.487C253.329 140.25 147.836 141.711 133.723 134.72"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="14"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M189.354 215.56C184.842 244.95 192.282 277.111 185.182 305.96"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M136.505 310.132C169.502 299.881 206.177 300.401 240.813 300.401"
        stroke={color}
        stroke-opacity="0.9"
        stroke-width="16"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
